module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Bezier-curve-231512dfb38d0de0491dca1df28aa776.svg";